export default {
  methods: {
    /**
     * クエリを受け取ってリメイクコードがあれば、そのまま返す
     * @param  {[type]} query [description]
     * @return {[type]}       [description]
     */
    getRemakeCode(query) {
      let code = query.make;
      return code ? code : null;
    },

    /**
     * クエリを受け取ってアクセサリコードがあれば、そのまま返す
     * @param  {[type]} query [description]
     * @return {[type]}       [description]
     */
    getAccessoryCode(query) {
      let code = query.code;
      return code ? code : null;
    },
  },
};
